import { render, staticRenderFns } from "./Epro.vue?vue&type=template&id=4f85438a&lang=pug"
import script from "./Epro.vue?vue&type=script&lang=js"
export * from "./Epro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports